import en from './en'
import zhCN from './zh-CN'
import zhCT from './zh-CT'
import jaJP from "./ja-JP"
import thTH from "./th-TH"
import zhTW from "./zh-TW"
export default {
  en,
  zhCN,
  zhCT,
  jaJP,
  thTH,
  zhTW
}